module.exports = __webpack_public_path__ + "img/coffee.5d213ce1.jpg";